import _ from 'lodash';
import Tone from 'tone';
import effects from './effects';
import MicrophoneInput from './microphone-input';
import Programmer from './newProgrammer';
export {};

const key = 'C Major Pentatonic';

window.tone = Tone;
// Affects tradeoffs between audio output latency and responsiveness:
// "interactive" (prioritizes low latency), "playback" (prioritizes sustained playback), "balanced" (balances latency and performance);
Tone.Transport.latencyHint = 1.5;
Tone.Transport.bpm.value = Math.round(35 + (Math.random() * 25));

const programmer = new Programmer(Tone, key);

// const mainOutput = new Tone().receive('effects').toMaster();

Tone.Master.chain.apply(Tone.Master, effects(() => {
  console.log('BPM', Tone.Transport.bpm.value);

  programmer.start();
  // window.micro = MicrophoneInput();
  // metronome.start(0);

  Tone.Transport.start(0);
}));


export default programmer;



// WEBPACK FOOTER //
// ./src/tones.js